import { render, staticRenderFns } from "./FreeReadPopup_video.vue?vue&type=template&id=5d821238&scoped=true"
import script from "./FreeReadPopup_video.vue?vue&type=script&lang=js"
export * from "./FreeReadPopup_video.vue?vue&type=script&lang=js"
import style0 from "./FreeReadPopup_video.vue?vue&type=style&index=0&id=5d821238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d821238",
  null
  
)

export default component.exports